import { CloseButton, Toast } from 'drywall';
import { css } from 'styled-components';
import token from 'styled-token';
import { StyledAnchor } from '../components/Anchor/Anchor.styles';
import { StyledIcon } from '../components/Icon/Icon.styles';
import { StyledText } from '../components/Text/Text.styles';
import { StyledTextButton } from '../components/TextButton/TextButton.styles';
import { hoverMediaQueryMixin } from './hoverMediaQueryMixin';
import { spaceMixin } from './spaceMixin';
import { typographyMixin } from './typographyMixin';
var appearanceCSS = function appearanceCSS(props) {
  var appearance = props.appearance;
  return token({
    background: "status." + appearance + ".background",
    borderColor: "status." + appearance + ".border",
    color: "status." + appearance + ".foreground"
  }, function (_ref) {
    var background = _ref.background,
      borderColor = _ref.borderColor,
      color = _ref.color;
    return css(["background:", ";border:1px solid ", ";", "{color:", ";}"], background, borderColor, Toast.Icon, color);
  })(props);
};
var inverseAppearanceCSS = function inverseAppearanceCSS(props) {
  var appearance = props.appearance;
  return token({
    background: "status." + appearance + ".darkBackground",
    color: 'colors.white',
    closeButtonBackgroundInverse: 'CloseButton.backgroundColorInverse'
  }, function (_ref2) {
    var background = _ref2.background,
      color = _ref2.color,
      closeButtonBackgroundInverse = _ref2.closeButtonBackgroundInverse;
    return css(["background:", ";border:0;&,", ",", ",", ",", "{color:", ";}", "{&,&:visited,&:active{color:", ";}", ";}", "{text-decoration:underline;}", "{&:hover,&:focus{background-color:", ";}}"], background, CloseButton, StyledText, StyledTextButton, Toast.Icon, color, StyledAnchor, color, hoverMediaQueryMixin("color: " + color + ";"), StyledTextButton, CloseButton, closeButtonBackgroundInverse);
  })(props);
};

/** @mixin statusDialogMixin */
/**
 * @method
 */
export var statusDialogMixin = function statusDialogMixin(props) {
  var inverse = props.inverse;
  return token({
    fontType: 'status.fontType',
    iconSize: 'status.iconSize'
  }, function (_ref3) {
    var fontType = _ref3.fontType,
      iconSize = _ref3.iconSize;
    return css(["box-sizing:border-box;padding:", ";", " ", " display:flex;", ",", ",", ",", "{flex:0 0 auto;}", ",", "{margin-left:", ";}", "{margin-right:", ";height:", "px;width:", "px;", "{height:100%;width:100%;}}", "{display:flex;}"], spaceMixin('sm')(props), inverse ? inverseAppearanceCSS(props) : appearanceCSS(props), typographyMixin(Object.assign({
      fontType: fontType
    }, props)), Toast.Body, Toast.Action, Toast.Close, Toast.Icon, Toast.Action, Toast.Close, spaceMixin('sm')(props), Toast.Icon, spaceMixin('sm')(props), iconSize, iconSize, StyledIcon, Toast.Close);
  })(props);
};